import type { StoreType } from '@mimir/web/store/state';
import { toAdminFeatures, toDesktopSettings, toFolders, toMyOrganization, toAllTenantsFeatures, toSupportTeamFeatures } from '@mimir/web/util/route';
import { canSeeAllTenantsFeatures, isSuperAdmin, isSupportTeam } from './util/security';
import type { Route, VueRouter } from 'vue-router/types/router';
import { isInAdobeApp, type ApplicationContext, isInElectron } from '@mimir/common/context/applicationContext';

export const hasRouteAccess = (applicationContext: ApplicationContext, route: Route,  store: StoreType) => {
  if (toAllTenantsFeatures(route)) {
    return canSeeAllTenantsFeatures();
  }
  if (toAdminFeatures(route)) {
    return store.getters.hasTenantInfoAccess;
  }
  if (toMyOrganization(route)) {
    return store.getters.hasTenantInfoAccess;
  }
  if (toDesktopSettings(route)) {
    return isInAdobeApp(applicationContext) || isInElectron(applicationContext);
  }
  if (toFolders(route)) {
    return store.state.config.tenantConfig.showFolderFunctionality;
  }
  if (toSupportTeamFeatures(route)) {
    return isSuperAdmin() || isSupportTeam() || store.getters.canPerformOwnTenantSupport;
  }

  return true;
};

export function redirectBackFromLoginPage(router: VueRouter): Promise<Route> {
  const redirect = router.currentRoute.query.redirectUrl?.toString();
  if (!redirect) {
    return Promise.resolve(router.currentRoute);
  }

  const target = decodeURIComponent(redirect);
  if (router.currentRoute.path == target) {
    return Promise.resolve(router.currentRoute);
  }

  return router.push(target);
}
